import { getPathwayTemplates } from '@/api/pathwayTemplates';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialValues = {
  pathwayTemplates: null,
  searchQuery: '',
  isSearching: false,
};

const usePathwayTemplatesStore = create()(immer(() => initialValues));
const { setState: set, getState: get } = usePathwayTemplatesStore;

export const pathwayTemplatesActions = {
  setPathwayTemplates: templates => set({ pathwayTemplates: templates }),

  searchPathwayTemplates: async query => {
    set(state => {
      state.searchQuery = query;
      state.isSearching = true;
    });

    try {
      const response = await getPathwayTemplates({ q: query });
      set(state => {
        state.pathwayTemplates = response.data;
        state.isSearching = false;
      });
    } catch (error) {
      set(state => {
        state.isSearching = false;
      });
      throw error;
    }
  },

  resetSearch: async () => {
    set(state => {
      state.searchQuery = '';
      state.isSearching = true;
    });

    try {
      const response = await getPathwayTemplates();
      set(state => {
        state.pathwayTemplates = response.data;
        state.isSearching = false;
      });
    } catch (error) {
      set(state => {
        state.isSearching = false;
      });
      throw error;
    }
  },

  loadMorePathwayTemplates: async () => {
    const { pathwayTemplates, searchQuery } = get();
    const next = pathwayTemplates?.next;

    if (next) {
      const url = new URL(next);
      const params = new URLSearchParams(url.search);
      const offset = params.get('offset');
      const limit = params.get('limit');

      const response = await getPathwayTemplates({
        offset,
        limit,
        ...(searchQuery && { q: searchQuery }),
      });

      set(state => {
        state.pathwayTemplates.results = [...state.pathwayTemplates.results, ...response.data.results];
        state.pathwayTemplates.next = response.data.next;
        state.pathwayTemplates.count = response.data.count;
      });
    }
  },

  hasMorePathwayTemplates: () => {
    const { pathwayTemplates } = get();
    return !!pathwayTemplates?.next;
  },
};

export const usePathwayTemplates = () => usePathwayTemplatesStore(store => store.pathwayTemplates?.results);
export const usePathwayTemplatesMeta = () =>
  usePathwayTemplatesStore(store => ({
    count: store.pathwayTemplates?.count,
    next: store.pathwayTemplates?.next,
    previous: store.pathwayTemplates?.previous,
  }));

export const usePathwayTemplatesSearch = () =>
  usePathwayTemplatesStore(store => ({
    searchQuery: store.searchQuery,
    isSearching: store.isSearching,
  }));
